class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    setTimeout(() => {
      const radios = this.querySelectorAll('.option-wrap.size .variant-row-list input[type="radio"]');
      if (radios.length === 1 && !radios[0].checked) {
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updateOptions();
      this.updateStockUrgency();
    }, 0);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.updateLengthSize();
      this.updateStockUrgency();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
updateLengthSize() {
    const lengthSize = this.querySelector('.length-size');
    const lengthSizeValue = lengthSize ? lengthSize.querySelector('.length-size-value') : null;
    var selectedInput = document.querySelector('.variant-row-list input[type="radio"]:checked[data-length]');
    var lengthValue = selectedInput ? selectedInput.getAttribute('data-length') : '';

    if (!lengthSize || !lengthSizeValue) return;
    lengthSizeValue.textContent = lengthValue;

    if (lengthValue && this.currentVariant) {
      lengthSize.classList.add('active');
    } else {
      lengthSize.classList.remove('active');
    }
}
updateStockUrgency() {
    const threshold = parseInt(this.dataset.threshold || 5);
    const urgencyContainer = this.querySelector('.stock-urgency');
    const stockCountSpan = this.querySelector('.stock-count');
    const selectedSize = this.querySelector('.option-wrap.size input[type="radio"]:checked');

    // Update dots for all sizes based on current selection (e.g. current color)
    const sizeRadios = this.querySelectorAll('.option-wrap.size input[type="radio"]');
    const variantData = this.getVariantData();

    sizeRadios.forEach(radio => {
        const sizeValue = radio.value;
        const currentOptions = [...this.options];
        const sizeIndex = parseInt(radio.closest('.option-wrap').dataset.index) - 1;
        currentOptions[sizeIndex] = sizeValue;

        const variant = variantData.find(v => {
            return !v.options.map((opt, i) => opt === currentOptions[i]).includes(false);
        });

        const label = radio.nextElementSibling;
        if (label) {
            let dot = label.querySelector('.low-stock-dot');
            if (variant && variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
                if (!dot) {
                    dot = document.createElement('span');
                    dot.classList.add('low-stock-dot');
                    label.appendChild(dot);
                }
            } else if (dot) {
                dot.remove();
            }
        }
        
        // Also update data-inventory for the urgency text logic
        if (variant) {
            radio.dataset.inventory = variant.inventory_quantity;
            radio.dataset.inventoryPolicy = variant.inventory_policy;
        }
    });

    if (!urgencyContainer || !stockCountSpan || !selectedSize) return;

    const inventory = parseInt(selectedSize.dataset.inventory || 0);

    if (inventory > 0 && inventory <= threshold) {
      stockCountSpan.textContent = inventory;
      urgencyContainer.style.display = 'inline-block';
    } else {
      urgencyContainer.style.display = 'none';
    }
}
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = fieldset.querySelector('input:checked');
      return checkedRadio ? checkedRadio.value : undefined;
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    var sold_out_btn = document.querySelector(".product-addcart");
    if(this.currentVariant != undefined){
     if (!this.currentVariant.available) {
       setTimeout(() => {
          sold_out_btn.classList.add('sold_out');
       }, "550")
      } else {
         setTimeout(() => {
          sold_out_btn.classList.remove('sold_out');
         }, "550")
      } 
    }
    if (!addButton) return;
    if (disable) {
      // addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('klaviyo-bis-trigger');
      // addButton.classList.add('sold_out');
      if (text) addButtonText.textContent = text;
    } else {
      // addButton.removeAttribute('disabled');
      addButton.classList.remove('klaviyo-bis-trigger');
      addButtonText.textContent = window.variantStrings.addToCart;
      // addButton.classList.remove('sold_out');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((data) => {
    if (data.status) {
      document.querySelector('.product-form-error').innerHTML = data.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){       
          
              var option_price = Shopify.formatMoney(data.final_price);
              // Ensure option variables exist so e-gift (no options) doesn't break
              var option_color = '';
              var option_size = '';
              var isGiftCard = data.gift_card;
              if (data.options_with_values && Array.isArray(data.options_with_values)) {
                data.options_with_values.forEach(function (option) {
                  if(option && option.name === "Color") {
                    option_color = option.value || option_color;
                  }
                  if(option && option.name === "Size") {
                    option_size = option.value || option_size; 
                  }
                });
              }
        // var pro_title = data.product_title.split("|")[0].split("-")[0];
        var pro_title = data.product_title.split("|")[0];
              document.querySelector("#cart-notification-product").innerHTML = "";        
              document.querySelector("#cart-notification-product").innerHTML = 
              `<div class="main_notification row">
                <div class="lef_notification">
                  <img src="${data.featured_image.url}" alt="${data.featured_image.alt}">
                </div>
                <div class="center_notification">
                  <div>
                  <p>${pro_title}</p>
                  <div class="pro_var mt-6">
                    <div class="singal_var">${isGiftCard ? '' : option_size + '/' + option_color}</div>
                  </div>
                </div>
                </div>
                <div class="right_notification">
                  <div class="cart-price">${option_price}</div>
                </div>
              </div>`;
          

          setTimeout(() => {
            $('.main_cart_notification').addClass('active');
          }, "1500")
          setTimeout(() => {
            $('.main_cart_notification.active').removeClass('active');
          }, "5000")

        load_cart();
        // setTimeout(function(e){
        //   document.querySelector('body').classList.add('open-drawer');
        // },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}


const colorSelectItems = document.querySelectorAll(".color_select_img li");

colorSelectItems.forEach(function(item) {
  item.addEventListener("mouseenter", function() {

    this.classList.add("active_hover");
    this.closest("ul").classList.add("hover_active");
    document.querySelector('.pro_color_var span').textContent = this.dataset.color;
  });

  item.addEventListener("mouseleave", function() {
    this.classList.remove("active_hover");
    this.closest("ul").classList.remove("hover_active");
    const activeItem = document.querySelector('.color_select_img li.active');
    if (activeItem) {
      document.querySelector('.pro_color_var span').textContent = activeItem.dataset.color;
    }
  });
});

// const imageContainer = document.querySelector('.medialist');
// const images = imageContainer.querySelectorAll('.media-grid-column');
// const checkViewportButton = document.querySelector('.desk_zoom');

// function isElementInViewport(element) {
//   const rect = element.getBoundingClientRect();
  
//   return (
//     rect.top >= 0 &&
//     rect.bottom / 2 <= (window.innerHeight) 
//   );
// }

// function checkImagesInViewport() {
//   images.forEach((image, index) => {
//     if (isElementInViewport(image)) {
//       // Highlight or display the image that is in the viewport
// console.log(image);
//       image.classList.add('active');
//     } else {
//       // Remove any previous highlighting
//       if(image.classList.contains("active")){
//         image.classList.remove('active');
//       }
//     }
//   });
// }

// checkViewportButton.addEventListener('click', checkImagesInViewport);
$(document).on('click', '.main_wear_it .variant-single', function () {
    // Remove 'focus' class from all variant elements
    $('.main_wear_it .variant-single').removeClass('focus');
    
    $(this).addClass('focus');
    $('.custom-add-to-cart').addClass('none');
    $(this).closest('.singal_wear_it').find('.custom-add-to-cart').removeClass('none');
    var dataId = $(this).data('id');
    $(this).closest('.singal_wear_it').find('.custom-add-to-cart .btn-add').data('id', dataId);
});

$(document).on('click', '.singal_var', function () {
   $('.disable').removeClass('disable');
});

// document.querySelectorAll('.yotpo-sr-bottom-line-button').forEach(summary => {
//   summary.addEventListener('click', e => {
//     e.preventDefault();

//     const target = document.querySelector('.yotpo-widget-clear');
//     if (target) {
//       const offset = 100;
      
//       requestAnimationFrame(() => {
//         const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
        
//         window.scrollTo({
//           top: targetTop,
//           behavior: 'smooth'
//         });
//       });
//     }
//   });
// });

document.querySelectorAll('.view-more-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    const target = document.querySelector('.section-accordion');
    if (target) {
      const offset = 150;
      
      requestAnimationFrame(() => {
        const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
        
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });
    }
  });
});


if (window.innerWidth > 991) {
document.querySelectorAll('.zoom_popup').forEach(block => {
  const btn = block.querySelector('.close-own-arrow');
  const infos = block.querySelectorAll('.pdp-zoom-media-thumbnail');
  let mouseX = 0, mouseY = 0;
  let btnX = 0, btnY = 0;
  let animationFrame;

  const updatePosition = () => {
    btnX += (mouseX - btnX) * 0.2;
    btnY += (mouseY - btnY) * 0.2;

    btn.style.left = `${btnX}px`;
    btn.style.top = `${btnY}px`;

    animationFrame = requestAnimationFrame(updatePosition);
  };

  block.addEventListener('mouseenter', (e) => {
    const rect = block.getBoundingClientRect();
    // include scrollTop and scrollLeft
    mouseX = e.clientX - rect.left + block.scrollLeft;
    mouseY = e.clientY - rect.top + block.scrollTop;

    btnX = mouseX;
    btnY = mouseY;

    btn.style.left = `${btnX}px`;
    btn.style.top = `${btnY}px`;

    animationFrame = requestAnimationFrame(updatePosition);
  });

  block.addEventListener('mousemove', (e) => {
    const rect = block.getBoundingClientRect();
    mouseX = e.clientX - rect.left + block.scrollLeft;
    mouseY = e.clientY - rect.top + block.scrollTop;
  });

  block.addEventListener('mouseleave', () => {
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
    btn.style.left = '';
    btn.style.top = '';
  });

  infos.forEach(info => {
    info.addEventListener('mouseenter', () => {
      btn.style.display = 'none';
    });

    info.addEventListener('mouseleave', () => {
      btn.style.display = 'flex';
    });
  });
});

}


document.addEventListener("DOMContentLoaded", () => {
  const thumbnails = document.querySelectorAll(".pdp-media-thumbnail img, .pdp-media-thumbnail video, .pdp-media-thumbnail iframe");
  const mediaColumns = document.querySelectorAll(".media-grid-column");

  if (!thumbnails.length || !mediaColumns.length) return;

  thumbnails[0].classList.add("active");
  mediaColumns[0].classList.add("active");

  let isUserScrolling = false;
  let scrollTimeout;

  window.addEventListener("scroll", () => {
    isUserScrolling = true;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isUserScrolling = false;
    }, 150);
  }, { passive: true });

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener("click", (e) => {
      e.preventDefault();

      thumbnails.forEach(t => t.classList.remove("active"));
      mediaColumns.forEach(m => m.classList.remove("active"));

      thumb.classList.add("active");
      const target = mediaColumns[index];
      if (target) {
        target.classList.add("active");

        const y = target.getBoundingClientRect().top + window.scrollY - 100;
        
        isUserScrolling = false;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      if (!isUserScrolling) return;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = [...mediaColumns].indexOf(entry.target);
          if (index !== -1) {
            thumbnails.forEach(t => t.classList.remove("active"));
            mediaColumns.forEach(m => m.classList.remove("active"));

            thumbnails[index].classList.add("active");
            mediaColumns[index].classList.add("active");

            requestAnimationFrame(() => {
              const thumbContainer = thumbnails[index].closest('.pdp-media-thumbnails');
              if (thumbContainer) {
                const thumbRect = thumbnails[index].getBoundingClientRect();
                const containerRect = thumbContainer.getBoundingClientRect();
                
                if (thumbRect.left < containerRect.left || thumbRect.right > containerRect.right) {
                  thumbnails[index].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                  });
                }
              }
            });
          }
        }
      });
    },
    { root: null, threshold: 0.6 }
  );

  mediaColumns.forEach(media => observer.observe(media));
});
// document.querySelectorAll('.media-grid-column').forEach(column => {
//   column.addEventListener('click', () => {
//     const zoomBtn = document.querySelector('.desk_zoom.block-991');
//     if (zoomBtn) {
//       zoomBtn.click();
//     }
//   });
// });
const zoomPopup = document.querySelector('.zoom_popup');
const closeBtn = document.querySelector('.close_zoom_popup');

if (zoomPopup && closeBtn) {
  zoomPopup.addEventListener('click', e => {
    if (e.target.closest('.media-grid-column')) {
      closeBtn.click();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const zoomPopup = document.querySelector(".zoom_popup");
  if (!zoomPopup) return;

  const thumbnails = zoomPopup.querySelectorAll(".pdp-zoom-media-thumbnail img, .pdp-zoom-media-thumbnail video, .pdp-zoom-media-thumbnail iframe");
  const mediaColumns = zoomPopup.querySelectorAll(".media-grid-column");

  if (!thumbnails.length || !mediaColumns.length) return;

  thumbnails[0].classList.add("active");
  mediaColumns[0].classList.add("active");

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener("click", (e) => {
      e.preventDefault();

      thumbnails.forEach(t => t.classList.remove("active"));
      mediaColumns.forEach(m => m.classList.remove("active"));

      thumb.classList.add("active");
      const target = mediaColumns[index];
      if (target) {
        target.classList.add("active");

        const scrollTop = target.offsetTop;
        zoomPopup.scrollTo({
          top: scrollTop,
          behavior: "smooth"
        });
      }
    });
  });

  const checkActiveOnScroll = () => {
    const popupRect = zoomPopup.getBoundingClientRect();
    let activeIndex = 0;
    let highestVisibility = 0;

    mediaColumns.forEach((media, index) => {
      const rect = media.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, popupRect.bottom) - Math.max(rect.top, popupRect.top);

      if (visibleHeight > highestVisibility && visibleHeight > 100) { 
        highestVisibility = visibleHeight;
        activeIndex = index;
      }
    });

    thumbnails.forEach(t => t.classList.remove("active"));
    mediaColumns.forEach(m => m.classList.remove("active"));

    thumbnails[activeIndex]?.classList.add("active");
    mediaColumns[activeIndex]?.classList.add("active");
  };

  zoomPopup.addEventListener("scroll", checkActiveOnScroll);
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 991) {
    const desktopWishlist = document.querySelector(".wishlist.d-only");
    if (desktopWishlist) desktopWishlist.remove();
  }
});